<template>
  <div class="pokemon-detail">
    <!-- 左侧头像和编号 -->
    <div class="left-panel">
      <img class="poke-image" :src="pokemon?.sprites.front" alt="Pokemon Image" />
      <h2>{{ pokemon?.name }}</h2>
      <p>No. {{ pokemon?.id }}</p>
    </div>

    <!-- 右侧信息框 -->
    <div class="right-panel">
      <!-- 切换按钮 -->
      <div class="tab-buttons">
        <button :class="{ active: tab === 'base' }" @click="tab = 'base'">基础信息</button>
        <button :class="{ active: tab === 'moves' }" @click="tab = 'moves'">可学招式</button>
        <button :class="{ active: tab === 'extra' }" @click="tab = 'extra'">其他信息</button>
      </div>

      <!-- 内容区域 -->
      <div class="tab-content">
        <div v-if="tab === 'base'" class="section">
          <p><strong>属性：</strong>{{ pokemon?.type.join(' / ') }}</p>
          <div>
            <strong>特性：</strong>
            <div class="ability-card" v-for="ability in pokemon?.abilities" :key="ability.internal_name">
              <h4>{{ ability.display_name }}</h4>
              <p>{{ ability.description }}</p>
            </div>
          </div>
          <div>
            <strong>种族值：</strong>
            <ul>
              <li v-for="(value, stat) in pokemon?.base_stats" :key="stat">
                {{ stat }}: {{ value }}
              </li>
            </ul>
          </div>
        </div>

        <div v-if="tab === 'moves'" class="section scrollable">
          <div class="move-card" v-for="move in pokemon?.moves" :key="move.internal_name">
            <h4>{{ move.display_name }}（等级 {{ move.level }}）</h4>
            <p>类型：{{ move.type }} / 分类：{{ move.category }}</p>
            <p v-if="move.power !== null">威力：{{ move.power }}</p>
            <p>命中率：{{ move.accuracy }}%</p>
            <p>{{ move.effect_description }}</p>
          </div>
        </div>

        <div v-if="tab === 'extra'" class="section">
          <p><strong>进化等级：</strong> {{ pokemon?.evolution?.level || '—' }}</p>
          <p><strong>进化到：</strong> No.{{ pokemon?.evolution?.evolves_to || '—' }}</p>
          <p><strong>性别比例：</strong> ♂ {{ pokemon?.gender_ratio.male }}% / ♀ {{ pokemon?.gender_ratio.female }}%</p>
          <p><strong>身高：</strong> {{ pokemon?.height }} m</p>
          <p><strong>体重：</strong> {{ pokemon?.weight }} kg</p>
          <p><strong>孵化步数：</strong> {{ pokemon?.hatch_steps }} 步</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PokemonDetail',
  data() {
    return {
      pokemon: null,
      tab: 'base', // 当前选中的按钮
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$axios.get(`/pokedex/${id}`).then(res => {
      this.pokemon = res.data;
    });
  },
};
</script>

<style scoped>
.pokemon-detail {
  display: flex;
  height: 100vh;
  background: #f0f0f0;
}

.left-panel {
  width: 40%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.poke-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
  margin-bottom: 10px;
}

.right-panel {
  width: 60%;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.tab-buttons button {
  padding: 8px 16px;
  border: none;
  background: #ddd;
  cursor: pointer;
  border-radius: 6px;
}

.tab-buttons .active {
  background: #4caf50;
  color: white;
}

.tab-content {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  overflow: hidden;
}

.section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.scrollable {
  max-height: 350px;
  overflow-y: auto;
}

.ability-card,
.move-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  background: #f9f9f9;
}

.ability-card h4,
.move-card h4 {
  margin: 0 0 5px;
  font-size: 16px;
}

.ability-card p,
.move-card p {
  margin: 3px 0;
  font-size: 14px;
}
</style>
